import { useMemo } from 'react';
import { FormSchemaConfig } from '../../types/form/schema.types';
import { FormState } from '../../types';
import {
  createCommentsTextarea,
  createGroupedApprovalSection,
  createRejectionTextarea,
  createStandardDisabledState,
  createYesNoRadio,
} from '../shared';

const SECTION_KEY = 'dubai_payment_from_office_account_approver';

// ============= Component =============
export const useDubaiPaymentFromOfficeAccountApproverSchema = (
  formState: FormState
): FormSchemaConfig => {
  return useMemo<FormSchemaConfig>(() => {
    const isDisabled = createStandardDisabledState(formState, SECTION_KEY);
    const approverSection = createGroupedApprovalSection({
      title: 'Payment Authorisation - Approver',
      fields: [
        createYesNoRadio({
          name: 'approverAuthApprove',
          label: 'Do you wish to authorise this payment?',
          disabled: isDisabled,
          validationMessage:
            'Please select whether you authorize this payment',
          isInvalid: (value: unknown): boolean => !value,
        }),
        createRejectionTextarea({
          name: 'approverRejectionDetails',
          label: 'Rejection Details',
          disabled: isDisabled,
          decisionField: 'approverAuthApprove',
          validationMessage: 'Please enter the rejection details',
          isInvalid: (value: unknown): boolean => !value,
        }),
        createCommentsTextarea({
          name: 'approverApprovalDetails',
          label: 'Additional Comments',
          disabled: isDisabled,
          decisionField: 'approverAuthApprove',
        }),
      ],
    });

    return {
      sections: [approverSection],
      dependencies: {
        showWhen: [
          {
            field: 'dubai_payment_from_office_account_payment_details',
          },
        ],
      },
    };
  }, [formState]);
};
